/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, GetProp, Input, notification } from 'antd';
import Toast from 'components/shared/Alert';

import { confirmWithPIN } from 'queries/ossix/user/userData';
import {
  getAccountTransactionsSummary,
  requestLinkedAccountBalance,
} from 'queries/ossix/wallet/requestWallet';
import { useEffect, useState } from 'react';
import { getCurrentMonthRange } from 'utils/getDateRange';

export default ({
  userData = {},
  selectedAccount,
}: {
  userData?: any;
  selectedAccount?: any;
}) => {
  const [form] = Form.useForm();
  const [isBalanceVisible, setIsBalanceVisible] =
    useState<boolean>(false);
  const [isInSightBalanceVisible, setIsInSightBalanceVisible] =
    useState<boolean>(false);
  const [api, contextHolder] = notification.useNotification();
  const [pin, setPin] = useState<string>('');
  const [openModel, setOpenModal] = useState<boolean>(false);

  const { MonthName, ...restOfKey } = getCurrentMonthRange();

  const {
    loadCheckUSerPIN,
    isCheckUSerPINError,
    isCheckUSerPINSuccess,
    checkUSerPINMessage,
    clearData: requestClearConfirmationData,
    mutate: requestPINConfirmation,
  } = confirmWithPIN();

  const {
    transactionSummaryData,
    loadTransactionSummary,
    isTransactionSummaryError,
    isTransactionSummarySuccess,
    transactionSummaryMessage,
    mutate: requestTransactionSummary,
    clearData: clearTransactionSummary,
  } = getAccountTransactionsSummary();

  const {
    isAccountBalanceError,
    accountBalanceData,
    isAccountBalanceSuccess,
    accountBalanceMessage,
    mutate: requestAccountBalance,
    clearData: clearAccountBalance,
  } = requestLinkedAccountBalance();

  const handleToggleVisibility = () => {
    requestPINConfirmation({ PIN: pin });
  };

  const handleInsightVisibility = () => {
    requestTransactionSummary({
      ...restOfKey,
      AccountNumber:
        selectedAccount?.AccountNumber || userData?.AccountNumber,
    });
  };

  const handleToggleHide = () => {
    setIsBalanceVisible(!isBalanceVisible);
  };

  const handleToggleHideInsight = () => {
    setIsInSightBalanceVisible(false);
    clearTransactionSummary();
  };

  const onHandleCloseModal = () => {
    setOpenModal(false);
    requestClearConfirmationData();
    setPin('');
    form.resetFields();
  };

  const onHandleOpenModal = () => setOpenModal(true);

  const onPINValuesChange: GetProp<typeof Input.OTP, 'onChange'> = (
    value: any,
  ) => setPin(value);

  useEffect(() => {
    if (isCheckUSerPINSuccess) {
      requestAccountBalance({
        CountryCode: userData?.CountryCode,
        AccountNumber: userData?.OriginalAccountNumber,
        OriginalAccountNumber: userData?.OriginalAccountNumber,
        PhoneNumber: userData?.PhoneNumber,
      });
      if (!isInSightBalanceVisible) {
        handleInsightVisibility();
      }
      setIsBalanceVisible(!isBalanceVisible);
      onHandleCloseModal();
    }
    if (isCheckUSerPINError) {
      Toast(api, 'Error', checkUSerPINMessage);
      requestClearConfirmationData();
      clearTransactionSummary();
    }

    if (isTransactionSummarySuccess) {
      setIsInSightBalanceVisible(true);
      onHandleCloseModal();
    }
    if (isTransactionSummaryError) {
      Toast(api, 'Error', transactionSummaryMessage);
      clearTransactionSummary();
    }

    if (isAccountBalanceSuccess) {
      setIsInSightBalanceVisible(true);
      onHandleCloseModal();
    }
    if (isAccountBalanceError) {
      Toast(api, 'Error', accountBalanceMessage);
      clearAccountBalance();
    }
  }, [
    checkUSerPINMessage,
    isCheckUSerPINSuccess,
    isCheckUSerPINError,
    isTransactionSummaryError,
    isTransactionSummarySuccess,
    transactionSummaryMessage,
  ]);

  return {
    isBalanceVisible,
    contextHolder,
    loadCheckUSerPIN,
    handleToggleHide,
    handleToggleVisibility,
    openModel,
    setOpenModal,
    pin,
    onPINValuesChange,
    onHandleCloseModal,
    onHandleOpenModal,
    form,
    loadTransactionSummary,
    transactionSummaryData,
    isInSightBalanceVisible,
    handleToggleHideInsight,
    MonthName,
    accountBalanceData,
  };
};
